import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import routes from "./routes/index";
import Layout from "./layout/index";
import useAuthStore from "./store"; 

const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  return isLoginPage ? children : <Layout>{children}</Layout>;
};

// Protect routes for authenticated users only
const PrivateRoute = ({ element }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

// Prevent access to /login if already logged in
const PublicRoute = ({ element }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? <Navigate to="/smartdocument" replace /> : element;
};

const AppRoutes = () => {
  return (
    <Router>
      <LayoutWrapper>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Navigate to="/smartdocument" />} />
            {routes.map((route, index) => {
              const isLoginRoute = route.path === "/login";
              const RouteWrapper = isLoginRoute ? PublicRoute : PrivateRoute;

              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<RouteWrapper element={<route.component />} />}
                />
              );
            })}
          </Routes>
        </Suspense>
      </LayoutWrapper>
    </Router>
  );
};

export default AppRoutes;
